// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page[data-v-2914c0b0]{grid-gap:0;gap:0}main p[data-v-2914c0b0]{margin-top:1rem;margin-bottom:1rem}@media (min-width:1024px){main p[data-v-2914c0b0]{max-width:75%}}", ""]);
// Exports
module.exports = exports;
